import React from "react";
import {Spinner} from "@seismic/mantle";

export const Section = (props) => {

    return <table>
        <thead>
        <tr>
            {props.headers.map(x=> <th key={x}>{x}</th>)}
        </tr>
        </thead>
        <tbody>
        {props.children}
        </tbody>
    </table>

}